import 'can-construct-super';
import Control from "can-control";

const NavigationBase = Control.extend(
    {
        defaults: {}
    },
    {
        init() {
            const _this = this;


            window.addEventListener('scroll', function() {
                _this.handleScroll(_this.element)
            });

        },
        handleScroll(element) {

        }
    });

export default NavigationBase;
